import { createAsyncThunk } from "@reduxjs/toolkit";
import { del, get, patch, post } from "helpers/api_helper";

import {
  ADD_ROLE,
  DELETE_ROLE,
  GET_ALL_ROLES,
  GET_ROLES_LIST,
  ROLE_DETAILS,
  UPDATE_ROLE,
  UPDATE_ROLE_STATUS,
} from "helpers/url_helper";

export const getAllRoles = createAsyncThunk(GET_ALL_ROLES, async (payload) => {
  const response = await post(GET_ALL_ROLES, payload);
  return response;
});

export const getRolesList = createAsyncThunk(GET_ROLES_LIST, async () => {
  const response = await get(GET_ROLES_LIST);
  return response;
});

export const addRole = createAsyncThunk(ADD_ROLE, async (payload) => {
  const response = await post(ADD_ROLE, payload);
  return response;
});

export const updateRole = createAsyncThunk(UPDATE_ROLE, async (payload) => {
  const response = await patch(UPDATE_ROLE, payload);
  return response;
});

export const getRoleDetails = createAsyncThunk(
  ROLE_DETAILS,
  async (payload) => {
    const response = await post(ROLE_DETAILS, payload);
    return response;
  }
);

export const deleteRole = createAsyncThunk(DELETE_ROLE, async (payload) => {
  const response = await del(DELETE_ROLE, payload);
  return response;
});

export const updateRoleStatus = createAsyncThunk(
  UPDATE_ROLE_STATUS,
  async (payload) => {
    const response = await patch(UPDATE_ROLE_STATUS, payload);
    return response;
  }
);
